import { Box, Slider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@mui/material";
import ContainedButton from "../../../common/components/Buttons/ContainedButton";

function ParametersForm({ handle_submit, parameters, handle_slider_change, handle_input_change, activeStep, ready_to_generate_schedule }) {
  return (<form onSubmit={handle_submit}>
    <TableContainer>
      <Table size="small" sx={{
        '& thead th:first-of-type': {
          width: '20%'
        },
        '& thead th': {
          width: '50%'
        },
        '& thead th:last-child': {
          width: '30%'
        }
      }}>
        <TableHead>
          <TableRow className="uppercase">
            <TableCell>Parameter</TableCell>
            <TableCell>Input</TableCell>
            <TableCell>Value</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.entries(parameters).map(([key, parameter]) => <TableRow // className="flex justify-between items-center gap-4" 
            key={key} sx={{
              mb: 3
            }}>
            <TableCell className="uppercase">
              {key.split("_").join(" ")}
              {
                /* <Typography className="uppercase">
                </Typography> */
              }
            </TableCell>
            <TableCell>
              <Slider value={parameter.value} min={parameter.min} max={parameter.max} step={(parameter.max - parameter.min) / 10} // Sensible step calculation
                onChange={(_, newValue) => handle_slider_change(key, newValue)} />
            </TableCell>
            <TableCell>
              <TextField size="small" type="number" value={parameter.value} sx={{
                width: "100%"
              }} // inputProps={{
                //   min: parameter.min,
                //   max: parameter.max,
                //   step: (parameter.max - parameter.min) / 100, // Sensible step calculation
                // }}
                onChange={e => handle_input_change(key, e.target.value)} />
            </TableCell>
          </TableRow>)}
        </TableBody>
      </Table>
    </TableContainer>
    <Box className="flex justify-end">
      {activeStep === 2 && <ContainedButton type="submit" disabled={activeStep < 2 || !ready_to_generate_schedule
      } className={`disabled:bg-slate-200`} sx={{
        color: "white"
      }} title={ready_to_generate_schedule ? "Click to generate schedule" : 'Please Upload All Files to generate schedule'}>
        {ready_to_generate_schedule ? 'Generate Schedule' : 'Please upload all files to generate schedule'}
      </ContainedButton>}
    </Box>
  </form>);
}

export default ParametersForm;